module.exports = __webpack_public_path__ + "img/f6.5d6a66a4.png";